module.exports = __webpack_public_path__ + "img/icon_lecturePlayerBtn.ffd4f542.svg";